import http from './http';

/**
 * 系统相关接口（壁纸 / 批量任务）
 */

/** Bing 每日壁纸 */
export function bingWallpaper() {
  return http.get('/api/system/bing/wallpaper');
}

/** URL 抓取入库 */
export function fetchRes(url, config = {}) {
  return http.post('/api/system/fetchRes', { url }, config);
}

/** 批量任务：文件列表 */
export function batchList(params, config = {}) {
  return http.get('/api/system/batch/list', { params, ...config });
}

/** 批量任务：读取设置 */
export function batchSettings() {
  return http.get('/api/system/batch/settings');
}

/** 批量任务：分片恢复数据 */
export function restoreChunk(payload, config = {}) {
  return http.post('/api/system/batch/restore/chunk', payload, config);
}

/** 批量任务：索引重建（读取配置 / 分片写入 / 最终提交） */
export function indexConfig() {
  return http.get('/api/system/batch/index/config');
}

export function indexChunk(payload, config = {}) {
  return http.post('/api/system/batch/index/chunk', payload, config);
}

export function indexFinalize(payload, config = {}) {
  return http.post('/api/system/batch/index/finalize', payload, config);
}
